import {
  Heading,
  HStack, Stack, Text as ChakraText, useDisclosure
} from '@chakra-ui/react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseLayout } from '..'
import { colors } from '../../../ui-kit'
import {
  PlanUpgradeModal
} from '../../components/Billing'
import { Plans } from '../../components/Billing/PlanUpgrade/NewPlan'
import { UserContext } from '../../providers'
import { MainContentHeadingBox, MainContentWrapper } from '../Base/MainContent'

const PlanUpgradeLayout = (): React.ReactElement | null => {
  const { t } = useTranslation()

  const {
    isOpen: isOpenPlanUpgrade,
    onClose: onClosePlanUpgrade,
    onOpen: onOpenPlanUpgrade,
  } = useDisclosure()

  const { user } = useContext(UserContext)

  if (!user) {
    return null
  }

  const DAM_ONLY_PLAN = user?.pricingPlan?.planType === "DAM_ONLY";
  const paidPlan = DAM_ONLY_PLAN ? user.damPremiumPlan : user.premiumPlan

  const stripePromise = loadStripe(user.stripePublishKey)

  return (
    <>
      <BaseLayout>
        <MainContentHeadingBox>
          <Stack direction={['column']} spacing={1}>
            <Heading
              as="h2"
              size="md"
              fontWeight="600"
              color={colors.appDarkIndigo}
            >
              Upgrade to {paidPlan.planName}
            </Heading>
            <ChakraText color="appBattleshipGrey">
              {t(
                'plan_upgrade_description',
                'Get access to a range of advanced features and functionalities by upgrading.',
              )}
            </ChakraText>
          </Stack>

        </MainContentHeadingBox>
        <MainContentWrapper>
          <HStack w="full" alignItems="flex-start" justifyContent="center" marginTop={12}>
            <Plans user={user} onOpenPlanUpgrade={onOpenPlanUpgrade} />
          </HStack>
        </MainContentWrapper>
      </BaseLayout>
      <Elements stripe={stripePromise}>
        <PlanUpgradeModal
          isOpen={isOpenPlanUpgrade}
          onClose={onClosePlanUpgrade}
          user={user}
        />
      </Elements>
    </>
  )
}

export default PlanUpgradeLayout
